import { Album, CATEGORY_COLORS, CATEGORY_ICON } from '@/mocks/portfolio';

interface AlbumCardProps {
  album: Album;
  onClick: (album: Album) => void;
}

export default function AlbumCard({ album, onClick }: AlbumCardProps) {
  const photoCount = album.photos.length;

  return (
    <div
      className="group relative bg-[#141210] border border-white/8 rounded-2xl overflow-hidden cursor-pointer hover:border-[#c9a55a]/35 transition-all duration-300 hover:-translate-y-1"
      onClick={() => onClick(album)}
    >
      {/* Cover Image */}
      <div className="relative w-full h-56 overflow-hidden">
        <img
          src={album.cover}
          alt={album.title}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-107"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0d0d0d]/80 via-[#0d0d0d]/20 to-transparent" />

        {/* Category badge */}
        <div className="absolute top-3 left-3">
          <span className={`inline-flex items-center gap-1.5 text-xs font-bold px-3 py-1.5 rounded-full ${CATEGORY_COLORS[album.category]}`}>
            <i className={`${CATEGORY_ICON[album.category]} text-xs`} />
            {album.category}
          </span>
        </div>

        {/* Photo count badge */}
        <div className="absolute top-3 right-3">
          <span className="inline-flex items-center gap-1 bg-black/60 backdrop-blur-sm text-white/80 text-xs font-semibold px-2.5 py-1.5 rounded-full border border-white/10">
            <i className="ri-image-line text-xs" />
            {photoCount} {photoCount === 1 ? 'photo' : 'photos'}
          </span>
        </div>

        {/* Open icon on hover */}
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="w-14 h-14 flex items-center justify-center bg-[#c9a55a]/90 rounded-full">
            <i className="ri-folder-open-line text-[#0d0d0d] text-2xl" />
          </div>
        </div>
      </div>

      {/* Info */}
      <div className="p-5">
        <h3 className="text-white font-bold text-base mb-1 leading-tight group-hover:text-[#c9a55a] transition-colors duration-200">
          {album.title}
        </h3>
        <p className="text-white/40 text-xs flex items-center gap-1 mb-3">
          <i className="ri-map-pin-line" />
          {album.location}
        </p>
        <p className="text-white/50 text-xs leading-relaxed line-clamp-2">
          {album.description}
        </p>

        {/* Footer row */}
        <div className="mt-4 pt-4 border-t border-white/6 flex items-center justify-between">
          <span className="text-white/30 text-xs">
            {photoCount} {photoCount === 1 ? 'photo' : 'photos'}
          </span>
          <span className="text-[#c9a55a] text-xs font-semibold flex items-center gap-1 group-hover:gap-2 transition-all">
            View Album <i className="ri-arrow-right-line" />
          </span>
        </div>
      </div>
    </div>
  );
}
